import { Root } from "./Root";
import { Row } from "./Row";
import { Head } from "./Head";
import { HeadCell } from "./HeadCell";
import { HeadName } from "./HeadName";
import { Body } from "./Body";
import { Cell } from "./Cell";

export const Table = {
    Root,
    Row,
    Head,
    HeadCell,
    HeadName,
    Body,
    Cell
};
